import { bool, func, oneOfType, shape, string } from 'prop-types';
import React from 'react';
import { Button, Modal } from 'reactstrap';

function createModalToggle(
  label, // Can be a string, node, or render function (called with the toggle props)
  ModalContent,
  buttonProps = {},
  modalProps = {},
) {
  class ModalToggle extends React.Component {
    constructor(props) {
      super(props);

      const { isOpenByDefault } = this.props;

      this.state = {
        isOpen: isOpenByDefault,
        confirmationMessage: false,
      };

      this.setConfirmationMessage = this.setConfirmationMessage.bind(this);
      this.handleSuccess = this.handleSuccess.bind(this);
      this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle(newValue) {
      const { confirmationMessage, isOpen } = this.state;
      const isOpening = typeof newValue === 'boolean' ? newValue : !isOpen;

      if (!isOpening && confirmationMessage) {
        // If a confirmation message is present and the modal is closing
        // eslint-disable-next-line no-alert
        if (window.confirm(confirmationMessage)) {
          // The modal should close only when the user confirms
          this.setState({ isOpen: false, confirmationMessage: '' });
        }
      } else {
        this.setState({ isOpen: isOpening });
      }
    }

    handleSuccess(...args) {
      this.setState({ isOpen: false });
      this.props.onSuccess(...args);
    }

    setConfirmationMessage(message) {
      this.setState({ confirmationMessage: message });
    }

    renderLabel() {
      if (typeof label === 'function') {
        return label(this.props);
      }

      return label;
    }

    render() {
      const {
        buttonId,
        disabled,
        isOpenByDefault,
        additionalButtonProps,
        onOpened,
        tag: Tag,
        ...additionalProps
      } = this.props;
      const { isOpen } = this.state;

      return (
        <>
          <Tag
            onClick={this.handleToggle}
            id={buttonId}
            disabled={disabled}
            {...buttonProps}
            {...additionalButtonProps}
          >
            {this.renderLabel()}
          </Tag>
          <Modal
            isOpen={isOpen}
            toggle={this.handleToggle}
            onOpened={onOpened}
            {...modalProps}
          >
            {isOpen && (
              <ModalContent
                toggle={this.handleToggle}
                setConfirmationMessage={this.setConfirmationMessage}
                {...additionalProps}
                onSuccess={this.handleSuccess}
              />
            )}
          </Modal>
        </>
      );
    }
  }

  ModalToggle.propTypes = {
    buttonId: string,
    disabled: bool,
    onSuccess: func,
    onOpened: func,
    isOpenByDefault: bool,
    additionalButtonProps: shape(Button.propTypes),
    tag: oneOfType([func, string]),
  };

  ModalToggle.defaultProps = {
    buttonId: undefined,
    disabled: false,
    onSuccess: () => {},
    onOpened: () => {},
    isOpenByDefault: false,
    additionalButtonProps: {},
    tag: Button,
  };

  return ModalToggle;
}

export default createModalToggle;
